<template>
	<div class="content">
		<div class="md-layout">

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<router-link to="/registration">
					<md-card>
						<md-card-media-cover>
							<md-card-media md-ratio="16:9">
								<img src="@/assets/img/card.png">
							</md-card-media>

							<md-card-area style="text-align: right;padding: 13px">
								<md-button class="md-primary">
									{{$store.state.locale.locale.registration[$store.state.locale.lang]}}
								</md-button>
							</md-card-area>
						</md-card-media-cover>
					</md-card>
				</router-link>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<router-link to="/redeem">
					<md-card>
						<md-card-media-cover>
							<md-card-media md-ratio="16:9">
								<img src="@/assets/img/card.png">
							</md-card-media>

							<md-card-area style="text-align: right;padding: 13px">
								<md-button class="md-primary">
									{{$store.state.locale.locale.ticketCheck[$store.state.locale.lang]}}
								</md-button>
							</md-card-area>
						</md-card-media-cover>
					</md-card>
				</router-link>
			</div>

			<!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<router-link to="/tracking">
					<md-card>
						<md-card-media-cover>
							<md-card-media md-ratio="16:9">
								<img src="@/assets/img/card.png">
							</md-card-media>

							<md-card-area style="text-align: right;padding: 13px">
								<md-button class="md-primary">
									{{$store.state.locale.locale.status[$store.state.locale.lang]}}
								</md-button>
							</md-card-area>
						</md-card-media-cover>
					</md-card>
				</router-link>
			</div> -->

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: {
			StatsCard
		},
		created() {
			// this.$http.get(this.config.api + "/admin/get/stat").then(data => {
			// 	this.stat = data.body.data

			// });
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue